import {IncidentManager} from "@advthreat/ribbon-components";
import axios from "axios";
import {isBoolean} from "lodash-es";
import moment from "moment";
import {appConfig} from "../config/defaultConfig";
import {FieldNames} from "../models/fields";
import {extractXHitsHeader} from "./utils/incidents";

const PRIVATE_INTEL_PROXY = appConfig.APP.PRIVATE_INTEL_PROXY;
const CTIA_SERVICES = appConfig.APP.CTIA_SERVICES;

export function fetchIncidents({
  assigneeQuery,
  dateRangeQuery,
  highImpact,
  page = 1,
  pageCount,
  searchText,
  orderBy,
  order,
  statusQuery
}) {
  const params = {
    query:
      [statusQuery, assigneeQuery, searchText].filter(Boolean).join(" && ") ||
      "*",
    sort_order: order?.toLowerCase(),
    sort_by: orderBy?.toLowerCase(),
    offset: (page - 1) * pageCount,
    limit: pageCount,
    from: dateRangeQuery?.from,
    to: dateRangeQuery?.to,
    ...(isBoolean(highImpact) && {high_impact: highImpact})
  };

  // API payload signature changes if we are sorting by multiple fields
  if (params.sort_by === FieldNames.scoresGlobal) {
    params.sort_by += `:${params.sort_order},${FieldNames.created}:desc`;
    delete params.sort_order;
  }

  return axios
    .get(PRIVATE_INTEL_PROXY.ROUTES.INCIDENT_SEARCH, {params})
    .then((response) => {
      return {
        dataRows: response.data,
        totalRows: extractXHitsHeader(response)
      };
    });
}

export const fetchIncidentsCount = () =>
  axios
    .get(PRIVATE_INTEL_PROXY.ROUTES.INCIDENT_SEARCH, {
      params: {
        query: "*",
        offset: 0,
        limit: 1,
        high_impact: true,
        from: moment().subtract(1, "year").toISOString()
      }
    })
    .then(extractXHitsHeader);

export const fetchUnassignedIncidentsCount = () =>
  axios
    .get(PRIVATE_INTEL_PROXY.ROUTES.INCIDENT_SEARCH, {
      params: {
        query: `!${FieldNames.assignees}:(*)`,
        offset: 0,
        limit: 1,
        high_impact: true,
        from: moment().subtract(1, "year").toISOString()
      }
    })
    .then(extractXHitsHeader);

export const fetchOpenIncidentsCount = () =>
  axios
    .get(PRIVATE_INTEL_PROXY.ROUTES.INCIDENT_SEARCH, {
      params: {
        query: `${FieldNames.status}:("Open")`,
        offset: 0,
        limit: 1,
        high_impact: true,
        from: moment().subtract(1, "year").toISOString()
      }
    })
    .then(extractXHitsHeader);

export const fetchNewIncidentsCount = () =>
  axios
    .get(PRIVATE_INTEL_PROXY.ROUTES.INCIDENT_SEARCH, {
      params: {
        query: `${FieldNames.status}:("New")`,
        offset: 0,
        limit: 1,
        high_impact: true,
        from: moment().subtract(1, "year").toISOString()
      }
    })
    .then(extractXHitsHeader);

export const patchIncidentStatus = (incidents, status) =>
  Promise.all(
    incidents.map((i) => {
      const {promise} = IncidentManager.changeIncidentStatus(i.id, status, {
        notify: false
      });
      return promise;
    })
  ).then((response) => response);

export const patchIncidentAssignees = (incidentId, assignees) => {
  const {promise} = IncidentManager.patchIncident(
    incidentId,
    {assignees},
    {notify: false}
  );
  return promise;
};

export const setBulkIncidentDelete = (data) =>
  axios.delete(`${PRIVATE_INTEL_PROXY.ROUTES.BULK_DELETE}`, {data});

export const linkIncidentsAPI = (data) =>
  axios.post(
    `${window.CONFIG.privateCtiaUrl}${CTIA_SERVICES.ROUTES.RELATIONSHIP}`,
    data
  );
